export default __webpack_public_path__ + "static/media/guide27.c77c042e.png";